import { useNavigate } from 'react-router-dom'

import { formatLocation } from '../../routes'
import { FirstArgument } from '../../utils/type-utils'

const goToInbox = (
  history: ReturnType<typeof useNavigate>,
  props: FirstArgument<typeof formatLocation['taskInbox']>,
) => void history(formatLocation.taskInbox(props))

const gotToView = (
	history: ReturnType<typeof useNavigate>,
	props: FirstArgument<typeof formatLocation['taskInbox']>,
) => {
	const viewMap: Record<
    NonNullable<typeof props.view>,
    (p: typeof props) => string
  > = {
    Pending: formatLocation.taskPending,
    InProgress: formatLocation.taskInProgress,
    InReview: formatLocation.taskPeerReview,
    Approved: formatLocation.taskApproved,
    Rejected: formatLocation.taskRejected,
  };

  const formatter = props.view ? viewMap[props.view] ?? formatLocation.taskInbox : formatLocation.taskInbox;
  void history(formatter(props));
}

export { goToInbox, gotToView };